const validations = {
	'date': () => ( import('./date') ),
}

export default validations;